import { makeStyles } from '@mui/styles';
const darkGray = '#263238';
const lightGray = '#3f505a';
const ligherGray = '#cfd8dc';
const green = '#508b46';
const blue = '#006cfc';
export const useStyles = makeStyles((theme) => {
  return {
    root: {
      boxShadow: 'none',
      border: '1px solid #cfd8dc',
      borderRadius: 4,
      background: '#f7f8f8',
      minHeight: '95px !important',
      padding: theme.spacing(0),
      paddingBottom: theme.spacing(0.5),
      boxSizing: 'border-box',
      margin: 0,
      borderTop: `4px solid #cfd8dc`,
      position: 'relative',
      '& .MuiAccordionSummary-content': {
        margin: 0,
        padding: 0,
      },
      '&.active': {
        borderTop: `4px solid ${green}`,
      },
    },
    content: {
      paddingBottom: theme.spacing(0.5),
    },
    expiredFlag: {
      background: ligherGray,
      borderBottomLeftRadius: 10,
      padding: theme.spacing(1, 2),
      paddingBottom: theme.spacing(1.5),
      marginTop: theme.spacing(-2),
      marginInlineEnd: theme.spacing(-2),
      color: '#455b64',
      fontSize: 13,
    },
    
    titlePart: {
      marginInlineEnd: 'auto',
    },
    titleText: {
      fontSize: 16,
      color: darkGray,
      fontWeight: 'normal',
    },
    subtitleText: {
      fontSize: 12,
      color: '#546e7a',
      fontWeight: 'normal',
      marginTop: theme.spacing(0.5),
    },
    actionButtons: {
      marginTop: theme.spacing(0),
      marginInlineStart: theme.spacing(-0.5),
    },
    actionButton: {
      color: blue,
      paddingInlineStart: theme.spacing(2),
      paddingInlineEnd: theme.spacing(2),
    },
    balanceTitle: {
      marginTop: theme.spacing(2),
      fontSize: 11,
      color: darkGray,
      fontWeight: 'bold',
    },
    balanceMoney: {
      fontSize: 16,
      color: darkGray,
      fontWeight: 'normal',
      '& span': {
        fontSize: 14,
        color: lightGray,
        marginInlineStart: theme.spacing(0.5),
      },
    },
    titleActions: {
      marginInlineEnd: theme.spacing(-1.5),
      marginTop: theme.spacing(-0.5),
    },
    actionsIcon: {
      marginInlineStart: theme.spacing(0.5),
      color: '#7d8f9b',
      padding: theme.spacing(1),
      '&:hover': {
        color: blue,
      },
    },
    propertyContainer: {
      marginTop: theme.spacing(3),
    },
    property: {
      fontSize: 14,
      color: lightGray,
      fontWeight: '400',
    },
    propertyIcon: {
      fontSize: 25,
      color: ligherGray,
      marginInlineEnd: theme.spacing(1),
      '&.active': {
        color: green,
      },
    },
    otherActions: {
      marginLeft: 'auto !important',
      marginRight: 'o !important',
    },
    otherActionsMenu: {
      border: '1px solid #d8d1d1',
    },
    otherActionsMenuItem: {
      padding: theme.spacing(1.5),
      color: darkGray,
      minWidth: 160,
      '&:hover': {
        color: blue,
      },
    },
    sheba: {
      marginTop: theme.spacing(1),
    },
    shebaNumber: {
      fontSize: 14,
      color: '#546e7a',
      fontWeight: 'normal',
      fontFamily: 'Vazir',
      overflowWrap: 'break-word',
    },
    copyIcon: {
      fontSize: 15,
    },
    copyIconButton: {
      width: 15,
      height: 15,
      marginInlineStart: theme.spacing(1),
      marginTop: -2,
    },
  };
});
